angular.module('app.filters').filter('facebookLiveSettings', () =>
    function(settings) {
        if (settings && settings.fb_feed_id && settings.fb_privacy) {
            const feedType = settings.fb_feed_id.split(':', 1)[0];
            const feedId = settings.fb_feed_id.replace(feedType+':', '');

            let url = null;
            if (settings.permalink_url) {
                url = settings.permalink_url;
            }

            let status = 'Linked';
            if (settings.fb_id) {
                status = 'Published';
            }

            let privacy = null;
            if (settings.fb_privacy == 'EVERYONE') {
                privacy = 'publicly';
            } else if (settings.fb_privacy == 'ALL_FRIENDS') {
                privacy = 'to friends';
            } else if (settings.fb_privacy == 'SELF') {
                privacy = 'privately';
            }

            let byWhom = null;
            if (settings.fb_user_name) {
                byWhom = settings.fb_user_name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }

            let dest = null;
            switch (feedType) {
                case 'event':
                    dest = 'to an event';
                    break;

                case 'group': // fall-through
                case 'page':
                    dest = 'to a ' + feedType;
                    break;

                case 'user':
                    dest = "to a user's timeline";
                    break;
            }
            return `Facebook: ${url ? `<a href="${url}" target="_blank">` : ''}${status}${privacy ? ` ${privacy}` : ''}${dest ? ` ${dest}` : ''}${byWhom ? ` by ${byWhom}` : ''}${url ? "</a>" : ''}`;
        } else {
            return 'Facebook: Not linked';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/facebook_live_settings.js